
import {
  defineComponent, shallowRef, onMounted, ref, watch,
} from 'vue';
import {
  Table, ConfigProvider,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {
  getMonitList,
} from '../caronMonit';

import store from '@/store';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
  },
  setup () {
    // 是否有数据
    const isEmpty = ref(false);
    // 列表行配置
    const columns = [
      {
        title: '区域',
        dataIndex: 'city',
        key: 'city',
        width: '10%',
        ellipsis: true,
      },
      {
        title: 'XCO2',
        dataIndex: 'CO2',
        key: 'CO2',
        width: '10%',
        ellipsis: true,
        sorter: (a:any, b: any) => a.CO2 - b.CO2,
      },
      {
        title: 'XCH4',
        dataIndex: 'CH4',
        key: 'CH4',
        width: '10%',
        ellipsis: true,
        sorter: (a:any, b: any) => a.CH4 - b.CH4,
      },
      {
        title: '监测时间',
        dataIndex: 'issue',
        key: 'issue',
        width: '10%',
        customRender: (data:any) => `${data.text.slice(0,4)}-${data.text.slice(4)}`,
        ellipsis: true,
      },
    ];

    // 表格数据
    const tableData = ref<any>([]);
    const getData = () => {
      getMonitList().then((result:any) => {
        const res = result.data;

        if (res && res.length) {
          tableData.value = res;
        } else {
          isEmpty.value = true;
        }
      });
    };

    getData();

    onMounted(() => {
      // console.log('onMounted');
    });

    return {
      zhCN,
      columns,
      tableData,
      isEmpty,
    };
  },
});
